/* this file is transformed by vux-loader */
/* eslint-disable */
import "vant/es/dialog/style";
import _Dialog from "vant/es/dialog";
import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import "vant/es/lazyload/style";
import _Lazyload from "vant/es/lazyload";
import "E:\\Huarz\\KOL\\vue-mobile\\node_modules\\core-js\\modules\\es.array.iterator.js";
import "E:\\Huarz\\KOL\\vue-mobile\\node_modules\\core-js\\modules\\es.promise.js";
import "E:\\Huarz\\KOL\\vue-mobile\\node_modules\\core-js\\modules\\es.object.assign.js";
import "E:\\Huarz\\KOL\\vue-mobile\\node_modules\\core-js\\modules\\es.promise.finally.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.number.to-fixed.js";
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import moment from 'moment';
Vue.config.productionTip = false;
[_Lazyload, _Toast, _Dialog].forEach(function (e) {
  Vue.use(e);
}); // 全局过滤器 - 日期格式化

Vue.filter('formatDate', function (value) {
  if (!value) return '';
  return moment(value).format('YYYY-MM-DD');
}); // 全局过滤器 - 日期格式化

Vue.filter('formatDateTime', function (value) {
  if (!value) return '';
  return moment(value).format("YYYY-MM-DD HH:mm");
}); // 全局过滤器 - 金额格式化

Vue.filter('formatCurrency', function (value) {
  if (isNaN(value)) return '¥0.00';
  return '¥' + parseFloat(value).toFixed(2);
});
import lodash from 'lodash';
Vue.prototype.$lodash = lodash;
import Methods from '@/common/utils/methods.js';
/* 公用方法 */

Vue.use(Methods);
import '@/common/utils/veeValidate.js';
/* 表单验证 */

import '@/common/utils/dateFormat.js';
/* 日期格式化 */

import '@/common/utils/weixin-js-sdk';
/* 微信js-sdk */

import '@/common/utils/ajax.js';
/* 引入封装后的axios */

import Enums from '@/common/config/enums.js';
/* 枚举值 */

Vue.prototype.Enums = Enums; // JS中使用css变量

import variables from '@/styles/variables.less';
Vue.prototype.variables = variables;
/* 动态修改tilte */

import VueWechatTitle from 'vue-wechat-title';
Vue.use(VueWechatTitle);
Vue.prototype.baseUrl = process.env.NODE_ENV == 'development' ? process.env.VUE_APP_URL : location.origin; // 忽略在 Vue 之外的自定义元素
// Vue.config.ignoredElements = ['wx-open-subscribe'];

import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);
router.beforeEach(function (to, from, next) {
  next();
});
Vue.config.productionTip = false;
new Vue({
  router: router,
  store: store,
  render: function render(h) {
    return h(App);
  }
}).$mount('#app');